
    import Vue from "vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import ApiClient from "@/utilities/ApiClient";
    import { PathwaySearchParameters } from "@/model/PathwaySearchParameters";
    import { IPathway } from "@/model/Pathway";
    import { previewVisitID } from "@/model/Enums";

    @Component({ components: { ApiButton } })
    export default class PreviewLinksDialogue extends Vue {

        showDialogue: boolean = false;
        pathwayList: Array<IPathway> = [];

        get linksText(): string {
            let baseUrl = ApiClient.baseUrl;
            if(!baseUrl || baseUrl === "/") {
                baseUrl = location.protocol + '//' + location.host + (!location.port || location.port === "80" ? "" : `:${location.port}`) + "/";
            }
            let text = "";
            for(const pathway of this.pathwayList) {
                text += `${pathway.description}\n${baseUrl}briefing/${previewVisitID}?previewPathwayID=${pathway.id}\n\n`;
            }
            return text;
        }

        get mailLink(): string {
            const body = encodeURIComponent(this.linksText);
            console.log("body = ", body);
            return `mailto:?subject=Site%20Safety%20Briefing%20Preview&body=${body}`;
        }

        async copyText() {
            await navigator.clipboard.writeText(this.linksText);
            toastr.info("copied");
        }

        async show(briefingID: string): Promise<void> {
            this.showDialogue = true;
            await this.loadPathways(briefingID);
        }

        async loadPathways(briefingID: string) {
            const searchParameters = new PathwaySearchParameters();
            searchParameters.briefingID = briefingID;
            this.pathwayList = await ApiClient.post("/Api/Pathway/Search", searchParameters);
            //this.pathwayList = mapData<Array<Pathway>>(data, { root: (s) => new Pathway (s) });
        }
    }
